// import Loader from '@/util/loader.js'
import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

// const loader = new Loader()
// Vue.prototype.loader = loader

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    // 今日世界-企业介绍
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    // 今日世界-品牌故事
    {
      path: '/story',
      name: 'story',
      component: () => import('./views/AboutStory.vue')
    },
    // 今日世界-形象大片
    {
      path: '/movie',
      name: 'movie',
      component: () => import('./views/AboutMovie.vue')
    },
    // 今日世界-资质荣誉
    {
      path: '/honor',
      name: 'honor',
      component: () => import('./views/AboutHonor.vue')
    },
    // 今日世界-发展历程
    {
      path: '/history',
      name: 'history',
      component: () => import('./views/AboutHistory.vue')
    },
    // 今日王国-产品引导
    {
      path: '/productgroups',
      name: 'productgroups',
      component: () => import('./views/Productgroups.vue')
    },
    // 今日王国-产品列表
    {
      path: '/products/:id',
      name: 'products',
      component: () => import('./views/Products.vue')
    },
    // 今日王国-产品详情
    {
      path: '/product/:fid/:id',
      name: 'product',
      component: () => import('./views/Product.vue')
    },
    // 生产基地
    {
      path: '/base',
      name: 'base',
      component: () => import('./views/Base.vue')
    },
    // 今日头条-新闻列表
    {
      path: '/medias/:id',
      name: 'medias',
      component: () => import('./views/Medias.vue')
    },
    // 今日头条-新闻详情
    {
      path: '/media/:fid/:id',
      name: 'media',
      component: () => import('./views/Media.vue')
    },
    // 人力资源
    {
      path: '/human',
      name: 'human',
      component: () => import('./views/Human.vue')
    },
    // 人力资源-招聘表单
    {
      path: '/job/:id',
      name: 'job',
      component: () => import('./views/Job.vue')
    },
    // 联系我们
    {
      path: '/contact',
      name: 'contact',
      component: () => import('./views/Contact.vue')
    },
    // 单页面
    {
      path: '/sangle/:id',
      name: 'sangle',
      component: () => import('./views/Sangle.vue')
    },
    // 单页面1
    {
      path: '/sangle1/:id',
      name: 'sangle1',
      component: () => import('./views/Sangle1.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  // loader.display()
  next()
})

export default router
